export default ({ $axios, $config: { apiBearerToken }, $winstonLog}) => {
  $axios.setToken(apiBearerToken, 'Bearer');

  $axios.onError((err) => {
    if ($winstonLog) {
      $winstonLog.error(err.toString());
    }
  });
}
